import {
  Box,
  Typography,
  Stack,
  Button,
  Divider,
} from "@mui/material";
import ArrowOutwardRoundedIcon from "@mui/icons-material/ArrowOutwardRounded";
import PhoneRoundedIcon from "@mui/icons-material/PhoneRounded";
import { motion } from "framer-motion";
import lilyLogo from "../../static/media/StrategicAllies/lily.webp";
import lilyBanner from "../../static/media/StrategicAllies/lilybanner.webp";

export default function LilyPartner() {
  return (
    <Box
      component="section"
      sx={{
        width: "100%",
        py: { xs: 2, md: 4 },
        bgcolor: "#ffffff",
      }}
    >
      <Box
        sx={{
          width: { xs: "92%", md: "86%" },
          maxWidth: "1300px",
          mx: "auto",
        }}
      >
        <Box
          sx={{
            borderRadius: { xs: "24px", md: "34px" },
            overflow: "hidden",
            background:
              "linear-gradient(135deg,#ffffff 0%,#f8fafb 45%,#eef3f4 100%)",
            border: "1px solid rgba(0,0,0,0.08)",
            boxShadow: "0 24px 70px rgba(0,0,0,0.08)",
          }}
        >
          <Box
            sx={{
              display: "grid",
              gridTemplateColumns: {
                xs: "1fr",
                md: "minmax(320px,420px) minmax(0,1.05fr)",
              },
              alignItems: "center",
              gap: { xs: 3, md: 15 },
              px: { xs: 2.2, sm: 3, md: 7 },
              py: { xs: 3, md: 3 },
            }}
          >
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
              }}
            >
              <motion.img
                src={lilyBanner}
                alt="Beneficios Lily Sunflower para miembros NovaXFit"
                initial={{ opacity: 0, x: -40 }}
                whileInView={{ opacity: 1, x: 0 }}
                viewport={{ once: true, amount: 0.3 }}
                transition={{ duration: 0.7 }}
                style={{
                  width: "100%",
                  maxWidth: "400px",
                  borderRadius: "22px",
                  boxShadow: "0 18px 50px rgba(0,0,0,0.12)",
                }}
              />
            </Box>

            <Box>
              <Stack
                spacing={{ xs: 2.1, md: 2.3 }}
                sx={{
                  alignItems: { xs: "center", md: "flex-start" },
                  textAlign: { xs: "center", md: "left" },
                }}
              >
                <motion.img
                  src={lilyLogo}
                  alt="Lily Sunflower Centro Estético Integral"
                  initial={{ opacity: 0, scale: 0.92 }}
                  whileInView={{ opacity: 1, scale: 1 }}
                  viewport={{ once: true }}
                  transition={{ duration: 0.6 }}
                  style={{
                    width: "100%",
                    maxWidth: "220px",
                    display: "block",
                  }}
                />

                <Typography
                  sx={{
                    color: "#111111",
                    fontWeight: 800,
                    letterSpacing: -0.7,
                    fontSize: { xs: 28, md: 34, lg: 38 },
                    lineHeight: 1.05,
                    maxWidth: 620,
                  }}
                >
                  15% de descuento exclusivo en tratamientos estéticos
                </Typography>

                <Typography
                  sx={{
                    color: "rgba(17,17,17,0.78)",
                    fontSize: { xs: 15.5, md: 16.2, lg: 16.8 },
                    fontWeight: 600,
                    lineHeight: 1.75,
                    maxWidth: 650,
                  }}
                >
                  Los miembros activos de NovaXFit reciben un 15% de descuento en
                  todos los tratamientos estéticos disponibles en Lily’s
                  Sunflower Centro Estético Integral.
                </Typography>

                <Stack
                  direction={{ xs: "column", sm: "row" }}
                  spacing={1.4}
                  sx={{
                    width: { xs: "100%", sm: "auto" },
                    pt: 0.4,
                    justifyContent: { xs: "center", md: "flex-start" },
                    alignItems: "center",
                  }}
                >
                  <motion.div
                    whileHover={{ scale: 1.04, y: -2 }}
                    whileTap={{ scale: 0.98 }}
                    style={{ width: "100%" }}
                  >
                    <Button
                      component="a"
                      href="https://www.lilysunflowers.com/"
                      target="_blank"
                      rel="noopener noreferrer"
                      endIcon={<ArrowOutwardRoundedIcon />}
                      sx={{
                        minHeight: 52,
                        width: { xs: "100%", sm: "auto" },
                        textTransform: "none",
                        fontWeight: 800,
                        borderRadius: "16px",
                        px: 2.8,
                        fontSize: 14.8,
                        color: "#ffffff",
                        background:
                          "linear-gradient(135deg,#0d8f92 0%,#22b4b8 48%,#066466 100%)",
                        boxShadow: "0 14px 34px rgba(34,180,184,0.28)",
                        "&:hover": {
                          filter: "brightness(1.05)",
                        },
                      }}
                    >
                      Visitar sitio web
                    </Button>
                  </motion.div>

                  <Stack
                    component="a"
                    href="https://wa.me/593984781610?text=Hola,%20quiero%20más%20información%20sobre%20los%20tratamientos%20estéticos%20con%20el%20beneficio%20NovaXFit"
                    target="_blank"
                    rel="noopener noreferrer"
                    direction="row"
                    spacing={1}
                    alignItems="center"
                    sx={{
                      textDecoration: "none",
                      cursor: "pointer"
                    }}
                  >
                    <PhoneRoundedIcon
                      sx={{
                        fontSize: 18,
                        color: "#22b4b8",
                      }}
                    />

                    <Typography
                      sx={{
                        color: "#000",
                        fontSize: { xs: 13.3, md: 13.6 },
                        fontWeight: 700,
                        "&:hover": {
                          color: "#22b4b8"
                        }
                      }}
                    >
                      0984781610
                    </Typography>
                  </Stack>
                </Stack>
              </Stack>
            </Box>
          </Box>
        </Box>

        <Box
          sx={{
            mt: { xs: 2.8, md: 3.4 },
            borderRadius: { xs: "22px", md: "28px" },
            background: "#ffffff",
            border: "1px solid rgba(0,0,0,0.08)",
            boxShadow: "0 16px 42px rgba(0,0,0,0.08)",
            px: { xs: 2.2, md: 3.2 },
            py: { xs: 2.2, md: 2.7 },
          }}
        >
          <Stack spacing={1.2}>
            <Typography
              sx={{
                color: "#111111",
                fontWeight: 800,
                fontSize: { xs: 18, md: 19 },
              }}
            >
              Términos y condiciones
            </Typography>

            <Divider sx={{ borderColor: "rgba(0,0,0,0.08)" }} />

            <Typography
              sx={{
                color: "rgba(17,17,17,0.72)",
                fontSize: { xs: 14.1, md: 14.7 },
                fontWeight: 700,
                lineHeight: 1.6,
              }}
            >
              Aplica únicamente para miembros activos de NovaXFit previa verificación.
            </Typography>

            <Typography
              sx={{
                color: "rgba(17,17,17,0.72)",
                fontSize: { xs: 14.1, md: 14.7 },
                fontWeight: 700,
                lineHeight: 1.6,
              }}
            >
              El descuento del 15% es válido en todos los tratamientos estéticos disponibles y no es acumulable con otras promociones vigentes.
            </Typography>
          </Stack>
        </Box>
      </Box>
    </Box>
  );
}